import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/semaglutide-versus-weight-loss-surgery-outcomes")({
  server: {
    handlers: {
      GET: async () => {
        return new Response(null, {
          status: 301,
          headers: { Location: "/dr-fitzer-dissects-the-news/semaglutide-versus-weight-loss-surgery-outcomes" },
        });
      },
    },
  },
});
